import { Input } from "@/components/ui/input";
import { PLATFORMS } from "@/components/site/PlatformLinks";

export const LinksFields = ({ links, onChange, keys, prefix }) => (
  <div className="grid sm:grid-cols-2 gap-3">
    {PLATFORMS.filter((p) => keys.includes(p.key)).map((p) => (
      <div key={p.key}>
        <label className="font-mono-tga text-[10px] uppercase tracking-[0.2em] text-zinc-500">{p.label}</label>
        <Input value={links[p.key] || ""} onChange={(e) => onChange({ ...links, [p.key]: e.target.value })} placeholder="https://…"
          className="bg-[#12141c] border-white/10 mt-1" data-testid={`${prefix}-link-${p.key}-input`} />
      </div>
    ))}
  </div>
);

export const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="font-mono-tga text-[10px] uppercase tracking-[0.2em] text-zinc-400">{label}</label>
    {children}
  </div>
);

export const inputCls = "bg-[#12141c] border-white/10";
